__turbopack_context__.v({
  "fadeIn": "R0gJMa_fadeIn",
  "plaa": "R0gJMa_plaa",
  "plaa__actions": "R0gJMa_plaa__actions",
  "plaa__backbtn": "R0gJMa_plaa__backbtn",
  "plaa__benefit": "R0gJMa_plaa__benefit",
  "plaa__benefit-text": "R0gJMa_plaa__benefit-text",
  "plaa__benefit-title": "R0gJMa_plaa__benefit-title",
  "plaa__benefits": "R0gJMa_plaa__benefits",
  "plaa__btn": "R0gJMa_plaa__btn",
  "plaa__card": "R0gJMa_plaa__card",
  "plaa__cards": "R0gJMa_plaa__cards",
  "plaa__content": "R0gJMa_plaa__content",
  "plaa__content--fluid": "R0gJMa_plaa__content--fluid",
  "plaa__content-inner": "R0gJMa_plaa__content-inner",
  "plaa__description": "R0gJMa_plaa__description",
  "plaa__main": "R0gJMa_plaa__main",
  "plaa__menuBackdrop": "R0gJMa_plaa__menuBackdrop",
  "plaa__menuBtn": "R0gJMa_plaa__menuBtn",
  "plaa__menuClose": "R0gJMa_plaa__menuClose",
  "plaa__menuHeader": "R0gJMa_plaa__menuHeader",
  "plaa__menuOverlay": "R0gJMa_plaa__menuOverlay",
  "plaa__menuTitle": "R0gJMa_plaa__menuTitle",
  "plaa__mobile-banner": "R0gJMa_plaa__mobile-banner",
  "plaa__placeholder": "R0gJMa_plaa__placeholder",
  "plaa__section": "R0gJMa_plaa__section",
  "plaa__section-title": "R0gJMa_plaa__section-title",
  "plaa__sidebar": "R0gJMa_plaa__sidebar",
  "plaa__subtitle": "R0gJMa_plaa__subtitle",
  "plaa__title": "R0gJMa_plaa__title",
  "rounds": "R0gJMa_rounds",
  "slideInRight": "R0gJMa_slideInRight",
});
